
import React, { useState } from 'react';
import IndustrySelector from './review/IndustrySelector';
import SentimentSelector from './review/SentimentSelector';
import ConversationDisplay from './review/ConversationDisplay';
import { IndustryType } from '@/data/industryData';

const IllustrationThree = () => {
  const [isPositive, setIsPositive] = useState(true);
  const [industry, setIndustry] = useState<IndustryType>("restauration");

  return (
    <div className="relative w-full max-w-2xl mx-auto">
      <div className="relative rounded-2xl border border-gray-200 shadow-md p-6 animated-gradient-bg">
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-400 rounded-full opacity-10 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-400 rounded-full opacity-10 blur-3xl"></div>
        
        <div className="relative flex flex-col gap-6">
          <div className="flex flex-col gap-3 mt-2">
            <IndustrySelector industry={industry} setIndustry={setIndustry} />
            <SentimentSelector isPositive={isPositive} setIsPositive={setIsPositive} />
          </div>
          
          <ConversationDisplay industry={industry} isPositive={isPositive} />
        </div>
      </div>
    </div>
  );
};

export default IllustrationThree;
